import React from "react";
import { Typography, theme } from "antd";

const { Text } = Typography;

interface FieldLabelProps {
  text: string;
}

const FieldLabel: React.FC<FieldLabelProps> = ({ text }) => {
  const { token } = theme.useToken();
  return (
    <Text
      style={{
        fontSize: 11,
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.07em",
        color: token.colorTextSecondary,
      }}
    >
      {text}
    </Text>
  );
};

export default FieldLabel;
